module.exports = __webpack_public_path__ + "assets/img/theX-content-6.8e037a0e.png";